import './src/fonts.css';
import wrapWithLayout from './wrap-with-layout.tsx';
import wrapWithProvider from './wrap-with-provider.tsx';

export const wrapPageElement = wrapWithLayout;
export const wrapRootElement = wrapWithProvider;
